import React from 'react';
import { Link } from 'react-router-dom';

const MessageInbox = ({ message }) => {
  
  const formatDate = (date) => {
    const d = new Date(date);
    return isNaN(d.getTime()) ? "N/A" : d.toISOString().split("T")[0];
  };

  return (
    <div id="inbox-message" className="col-sm-12 mb-5 pb-5">
      <div className="heading-golfer">
        <h4>Message Preview</h4>
      </div>
      
        <div id="msgheader">
          <h2>From: <b>{message.poster?message.poster:message.sender}</b></h2>
          <h2>Subject: <b>{message.subject}</b></h2>
        </div>
        <p className="msg-head">Message:</p>
        <div id="msg">
          {message.message}
        </div>
        {/* <p><strong>Date:</strong> {formatDate(message.date)}</p> */}
        <Link to= "/carter/msgboard" state={{ replyTo: message }} className="reply-link  d-inline-block pb-5 mb-5">Reply to Message</Link>
      </div>
   
  );
}

export default MessageInbox;
